import { memo } from "react";

import { UserStatus } from "../model/constants";

import {
  Select,
  SelectContent,
  SelectItem,
  Button,
  Card,
  CardContent,
  Input,
} from "@/common/components";
import { ROLE_LABELS } from "@/common/model";

const ROLE_OPTIONS = [
  { value: "all", label: "Все роли" },
  { value: "cargo_owner", label: ROLE_LABELS.cargo_owner },
  { value: "wagon_owner", label: ROLE_LABELS.wagon_owner },
  { value: "admin", label: ROLE_LABELS.admin },
];

interface UserFiltersProps {
  companyFilter: string;
  innFilter: string;
  roleFilter: string;
  status: UserStatus;
  onCompanyFilterChange: (value: string) => void;
  onInnFilterChange: (value: string) => void;
  onRoleFilterChange: (value: string) => void;
  onReset: () => void;
}

export const UserFilters = memo(function UserFilters({
  companyFilter,
  innFilter,
  roleFilter,
  status,
  onCompanyFilterChange,
  onInnFilterChange,
  onRoleFilterChange,
  onReset,
}: UserFiltersProps) {
  const isModerStatus = status === UserStatus.Admin;

  return (
    <Card className="mb-6">
      <CardContent className="">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <label className="block text-xs font-semibold text-Text-main leading-4 mb-1">
              Компания
            </label>
            <Input
              type="text"
              value={companyFilter}
              onChange={(e) => onCompanyFilterChange(e.target.value)}
              placeholder="Название компании"
              className="block"
            />
          </div>
          <div>
            <label className="block text-xs font-semibold text-Text-main leading-4 mb-1">ИНН</label>
            <Input
              placeholder="Введите ИНН"
              value={innFilter}
              onChange={(e) => onInnFilterChange(e.target.value)}
            />
          </div>
          <div>
            <label className="block text-xs font-semibold text-Text-main leading-4 mb-1">
              Роль
            </label>
            <Select
              key={roleFilter}
              value={isModerStatus ? "admin" : roleFilter}
              defaultValue={ROLE_OPTIONS.map((o) => o.value)[0]}
              onValueChange={onRoleFilterChange}
              disabled={isModerStatus}
            >
              <SelectContent>
                {ROLE_OPTIONS.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="flex items-end">
            <Button variant="outline" onClick={onReset} className="w-full">
              Сбросить
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
});
